export class LegListArea {
  constructor(
    public departureAreas: Array<string> = [],
    public arrivalAreas: Array<string> = [],
    public roundTrip: boolean = false
  ) {}
}
